import { Component } from '@angular/core';

@Component({
  selector: 'app-shopping-cart-icon',
  imports: [],
  templateUrl: './shopping-cart-icon.html',
  styleUrl: './shopping-cart-icon.scss'
})
export class ShoppingCartIcon {

}
